import { render, staticRenderFns } from "./programmeDetail.vue?vue&type=template&id=e02c20b4&"
import script from "./programmeDetail.vue?vue&type=script&lang=js&"
export * from "./programmeDetail.vue?vue&type=script&lang=js&"
import style0 from "./programmeDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports